module.exports =
{
  bedrooms: require('./NodeConfigurator/bedrooms'),
  floors: require('./NodeConfigurator/floors'),
  devices: require('./NodeConfigurator/devices'),
  summary: require('./NodeConfigurator/summary'),
  confirm: require('./NodeConfigurator/confirm'),
}